const messages = {
  units: {
    points: "pkt",
    piecesCount: "{count} szt.",
    piecesCountUnit: "szt.",
  },
  account: {
    title: "Stan konta",
    lastUpdate: "Ostatnia aktualizacja: {date}",
    noPointsYet: "Brak punktów",
    loading: "Ładowanie stanu konta…",
    toggleToPurchases: "Pokaż sekcję Twoje zakupy",
    toggleToFirstStop: "Pokaż stan konta First Stop",
    firstStopPanelButton: "Panel First Stop",
  },
  purchases: {
    title: "TWOJE ZAKUPY",
    yearLabel: "Rok: {year}",
    carMinimum: "min. 20 szt.",
    busMinimum: "min. 12 szt.",
    bikeMinimum: "min. 10 szt.",
    detailsButton: "Szczegóły zakupów",
  },
  quickLinks: {
    rules: {
      title: "Zasady Pasji",
      subtitle: "i tabela dopłat",
    },
    promotions: {
      title: "Promocje czasowe",
      subtitle: "i akcje specjalne",
    },
    knowledge: {
      title: "BRIDGESTONE Go",
      subtitle: "Wiedza & nagrody",
    },
  },
  bonusUhrd: {
    title: "Bonus UHRD",
    pointsLabel: "+75 pkt",
    goalLabel: "Twój cel: {count} szt.",
    goalAchievedLabel: "Cel osiągnięty: {count} szt.",
    beyondGoalPointsLabel: "+15 pkt",
    beyondGoalPointsPerUnit: "/szt.",
    beyondGoalTotalPointsLabel: "+180",
    beyondGoalTotalPointsUnit: "pkt",
    mockGoalAchievedToggle: "Mock: cel osiągnięty",
    detailsButton: "Sprawdź szczegóły bonusu",
    regsButton: "Regulamin",
  },
  bonusUhrdPage: {
    crumbHome: "Strona główna",
    crumbBonus: "Bonus UHRD",
    heroHeadline: "Zdobądź bonusowe punkty za wysokie cale",
    goalReminderEyebrow: "DO CELU JUŻ TYLKO",
    goalReminderDaysLeftLead: "Masz jeszcze: ",
    goalReminderDaysLeftEmphasis: "{days} dni",
    bonusPeriodLine: "Czas trwania: 01.01.2026 – 31.12.2026",
    periodLead: "Czas trwania:",
    periodDates: "01.01.2026 – 31.12.2026",
    rulesHeading: "ZASADY SĄ PROSTE:",
    rules: {
      passengerTyres: {
        title: "KUPUJ OPONY UHRD",
        description:
          "Bonusowe punkty otrzymasz za zakup opon osobowych 18” i większych.",
      },
      achieveAdv: {
        title: "OSIĄGNIJ SWÓJ CEL",
        points: "+75 pkt",
        description: "Osiągnij swój cel, otrzymasz pierwszy bonus:",
      },
      challengeAdv: {
        title: "JESZCZE WIĘCEJ PKT!",
        description:
          "Za każdą oponę powyżej celu dostajesz +15 pkt (maksymalnie +10 000 pkt!)",
      },
      rewardsHighlighted: {
        title: "NAGRODY ZA PUNKTY",
        description:
          "Bonusowe punkty trafią na Twoje konto przy rozliczeniu edycji. Wybierz nagrody!",
      },
    },
  },
  bonusGoals: {
    title: "Cele zakupowe",
  },
  bonusGoalsPage: {
    crumbHome: "Strona główna",
    crumbBonus: "Cele zakupowe",
    heroHeadline: "Realizuj cele zakupowe i zbieraj punkty Pasji",
    goalReminderEyebrow: "DO CELU JUŻ TYLKO",
    goalReminderDaysLeftLead: "Masz jeszcze: ",
    goalReminderDaysLeftEmphasis: "{days} dni",
    bonusPeriodLine: "Czas trwania: 01.01.2026 – 31.12.2026",
    rulesHeading: "ZASADY SĄ PROSTE",
    rules: {
      passengerTyres: {
        title: "ZBIERAJ PUNKTY ZA REALIZACJĘ CELÓW",
        description:
          "Wybrane kategorie zakupowe i progi są opisane w komunikacie kampanii oraz tabeli dopłat.",
      },
      achieveAdv: {
        title: "PIERWSZY PRÓG",
        points: "+2 000 pkt",
        description: "Po pierwszym zadeklarowanym progu przysługuje premia:",
      },
      challengeAdv: {
        title: "WYŻSZY PRÓG",
        points: "+3 000 pkt",
        description:
          "Osiągnięcie kolejnego limitu zwiększa liczbę punktów do wykorzystania przy nagrodach:",
      },
      rewardsHighlighted: {
        title: "NAGRODY ZA PUNKTY",
        description:
          "Zgromadzone punkty wymieniasz wg zasad Bridgestone na koniec rozliczenia okresu.",
      },
    },
  },
  bonusAwansPage: {
    crumbHome: "Strona główna",
    crumbBonus: "BONUS ZA AWANS",
    heroHeadline: "Zdobądź bonusowe punkty za AWANS",
    goalReminderEyebrow: "DO CELU JUŻ TYLKO",
    goalReminderEyebrowRemaining: "Jeszcze tylko",
    goalReminderDaysLeftLead: "Masz jeszcze: ",
    goalReminderDaysLeftEmphasis: "{days} dni",
    bonusPeriodLine:
      "Czas trwania: 01.01.2026 - 31.12.2026. Bonusy się nie sumują - otrzymujesz najwyższy zdobyty.",
    periodLead: "Czas trwania: ",
    periodDates: "01.01.2026 - 31.12.2026",
    periodNote: ". Bonusy się nie sumują - otrzymujesz najwyższy zdobyty.",
    rulesHeading: "ZASADY SĄ PROSTE",
    rules: {
      passengerTyres: {
        title: "KUPUJ OPONY OSOBOWE",
        description: "Do bonusu liczą się wszystkie zakupy opon osobowych.",
      },
      achieveAdv: {
        title: "OSIĄGNIJ SWÓJ CEL",
        points: "+2 000 pkt",
        description: "Osiągnij Twój cel, otrzymasz pierwszy bonus:",
      },
      challengeAdv: {
        title: "DASZ RADĘ?",
        points: "+3 000 pkt",
        description:
          "Udało się? Sprzedawaj jeszcze więcej, by zwiększyć bonus do",
      },
      rewardsHighlighted: {
        title: "NAGRODY ZA PUNKTY",
        description:
          "Bonusowe punkty trafią na Twoje konto przy rozliczeniu edycji. Wybierz nagrody!",
      },
    },
  },
  bonusAwans: {
    title: "BONUS ZA AWANS",
    detailsButton: "Sprawdź szczegóły bonusu",
    mockFirstMilestoneAchievedToggle: "Mock: pierwszy próg osiągnięty",
    milestones: {
      goal: {
        pointsLabel: "+2000 pkt.",
        label: "Twój cel: 200 szt.",
        achievedLabel: "Cel osiągnięty: {count} szt.",
      },
      challenge: {
        pointsLabel: "+3000 pkt.",
        label: "dasz radę? 400 szt.",
        remainingLabel: "Jeszcze tylko {count} szt.",
      },
    },
  },
  analytics: {
    pointsVsLastYear: {
      title: "Zdobyte punkty vs. rok ubiegły",
    },
    tiresVsLastYear: {
      title: "Zamówione opony vs. rok ubiegły",
    },
    purchasesByInch: {
      title: "Zakupy wg calarzu",
    },
    purchasesBySupplier: {
      title: "Zakupy wg hurtowni",
    },
    view: {
      chart: "Wykres",
      table: "Tabelka",
    },
    legend: {
      lastYear: "rok ubiegły",
      thisYear: "ten rok",
    },
    tireType: "Typ opon",
    tireTypes: {
      all: "Wszystkie",
      passenger: "Osobowe",
      truck: "Ciężarowe",
    },
    downloadXls: "Pobierz .xls",
    table: {
      month: "Miesiąc",
      label: "Kategoria",
      percent: "Udział %",
    },
    months: {
      jan: "sty",
      feb: "lut",
      mar: "mar",
      apr: "kwi",
      may: "maj",
      jun: "cze",
      jul: "lip",
      aug: "sie",
      sep: "wrz",
      oct: "paź",
      nov: "lis",
      dec: "gru",
    },
    inch: {
      15: '15"',
      16: '16"',
      17: '17"',
      18: '18"',
      19: '19"',
      20: '20"',
    },
    suppliers: {
      interCars: "Inter Cars",
      handlopex: "Handlopex",
      latex: "Latex",
    },
    surchargeTable: {
      title: "Tabela dopłat",
      diameterHeader: "Średnica opony",
      andMore: "i więcej",
      note1:
        "Tabela pokazuje ilość punktów przyznawanych za zakup 1 szt. opony w zależności od marki i średnicy.",
      note2: "Punkty aktywują się po osiągnięciu minimalnej ilości sztuk.",
      rulesButton: "Sprawdź zasady",
    },
  },
  promotions: {
    heading: "Wykorzystaj wszystkie promocje, zbierz maksymalną liczbę punktów!",
    pageBrandLabel: "Bridgestone Plus",
    pageTitle: "Promocje",
    pageIntro:
      "Przeglądaj wszystkie aktywne promocje, zapisuj się na te wymagające rejestracji i maksymalizuj liczbę punktów za zakupy opon.",
    pageListHeading: "Wszystkie dostępne promocje",
    filtersAriaLabel: "Filtruj promocje",
    filterAll: "Wszystkie",
    filterActive: "Aktywne",
    filterSignInRequired: "Wymaga zapisu",
    filterSigned: "Zapisane",
    viewAll: "Zobacz wszystkie promocje",
    detailsLink: "Szczegóły promocji",
    backToHome: "Powrót do strony głównej",
    backToList: "Powrót do listy promocji",
    loading: "Ładowanie promocji…",
    listView: "Widok listy",
    sliderView: "Widok slidera",
    cardButton: "Skorzystaj z promocji",
    signInButton: "Zapisz się na promocję",
    signedInButton: "Zapisano na promocję",
    signInSuccess: "Zapisano na promocję.",
    signInError: "Nie udało się zapisać na promocję. Spróbuj ponownie.",
    detailDescriptionTitle: "Opis promocji",
    detailRulesTitle: "Zasady",
    detailRelatedTitle: "Inne promocje",
    detailRewardLabel: "Nagroda",
    detailInfoTitle: "Informacje",
    detailInfoStatus: "Status",
    detailInfoStart: "Start",
    detailInfoEnd: "Koniec",
    detailInfoBonus: "Bonus",
    detailHelpTitle: "Potrzebujesz pomocy?",
    detailHelpText:
      "Masz pytania dotyczące tej promocji? Skontaktuj się z nami.",
    detailHelpContact: "Kontakt",
    detailNoDescription: "Brak opisu promocji.",
    detailPeriod: "Okres promocji: {start} – {end}",
    detailAutoApply: "Punkty naliczane automatycznie po zakupie.",
    detailNotFound: "Nie znaleziono promocji.",
    stats: {
      total: "Łącznie",
      active: "Aktywne",
      signInRequired: "Wymaga zapisu",
    },
    status: {
      active: "Aktywna",
      ending_soon: "Kończy się wkrótce",
      planned: "Wkrótce",
    },
    pointsLabel: {
      multiply: "x{value} więcej punktów",
      add: "+{value} pkt. za każdą oponę!",
    },
    items: {
      default: {
        description:
          "W tegorocznej edycji Pasji Bridgestone mamy aż 120 nagród. Twój stan konta pozwala Ci odebrać aż 88 z nich!",
      },
      doublePoints: {
        title: "Podwójne punkty za opony Ecopia Eliten Serii 60",
        pointsLabel: "x2 więcej punktów",
      },
      purchaseGoal: {
        title: "Dodatkowe punkty za realizację celu zakupowego",
        pointsLabel: "+1 pkt. za każdą oponę!",
      },
    },
  },
  rewards: {
    catalogView: "Widok katalogu",
    sliderView: "Widok slidera",
    slidesAriaLabel: "Slajdy katalogu nagród",
    showSlideAriaLabel: "Pokaż slajd {number}",
    claimButton: "Odbierz nagrodę",
    catalogTitle: "Zobacz cały KATALOG nagród",
    catalogDescriptionStart:
      "W tym roku mamy aż 120 nagrody. Aktualny stan konta pozwala Ci odebrać",
    catalogDescriptionEnd: "z nich!",
    exchangeButton: "Wymień punkty na nagrody",
    slides: {
      race: {
        title: "Nagroda tygodnia: dzień na torze wyścigowym",
        description:
          "Usiądź za kierownicą 1000-konnego potwora rajdowego. Gaz do dechy i... START!",
        points: "1400 pkt.",
      },
      voucher: {
        title: "Popularna nagroda: voucher do Media Expert",
        description:
          "Telefon? Telewizor? Coś do ogrodu lub na taras? Wymień punkty na super zakupy!",
        points: "od 500 pkt.",
      },
    },
  },
  benefits: {
    headingStart: "Wykorzystaj",
    headingHighlight: "wszystkie",
    headingEnd: "korzyści od Bridgestone:",
    tabs: {
      myApps: "Moje aplikacje",
      allApps: "Wszystkie aplikacje",
    },
    emptyMyApps:
      "Nie masz jeszcze przypisanych aplikacji. Przełącz na „Wszystkie aplikacje”, aby poprosić o dostęp.",
    openButton: "Otwórz",
    items: {
      survey: {
        title: "Ankieta o serwisie",
        description:
          "Wypełnij ankietę o swoim serwisie i zdobądź atrakcyjną nagrodę gwarantowaną!",
      },
      collection: {
        title: "COLLECTION",
        description:
          "Wybierz nagrody z ekskluzywnego katalogu produktów i gadżetów marki.",
      },
      drive: {
        title: "DRIVE",
        description:
          "Uzyskaj dostęp do bogactwa treści multimedialnych, które pomogą Ci sprzedawać.",
      },
      linkup: {
        title: "LINKUP",
        description:
          "Sprawdź, jak łatwo korzystać się z European customer care management.",
      },
    },
  },
  footer: {
    ariaLabel: "Stopka",
    links: {
      rules: "Zasady Programu",
      contact: "Kontakt",
      cookies: "Polityka ciasteczek",
      terms: "Regulamin",
      privacy: "Polityka prywatności",
      faq: "FAQ",
      e8: "E8",
    },
  },
};

export default {
  messages,
};
